import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../layout/PageHeader';
import { LOGO_SIZE } from '../../../ui/Logo';
import Hero from '../../../layout/Hero';
import heroImage from '../../../assets/images/rallies-bg.png';
import PageMainContent from '../../../layout/PageMainContent';
import TextContent from '../../../ui/TextContent';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Button from '../../../ui/Button';
import { useTranslation } from 'react-i18next';
import PageBottomContent from '../../../layout/PageBottomContent';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
import { getRally } from '../../../api/game-mode/rallies';
import RallyInfoCard from '../../../ui/RalliyInfoCard';
import PublicPageLayout from '../../../layout/PublicPageLayout';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
const RallyPreviewPage = () => {
    const { id } = useParams();
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [rally, setRally] = useState(null);
    useEffect(() => {
        const fetchRally = async () => {
            const rally = await getRally(id);
            if (rally) {
                setRally(rally);
            }
            else {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.rallyDoesNotExist.key));
            }
        };
        fetchRally();
    }, [i18n.language]);
    return (_jsx(PublicPageLayout, { children: _jsxs("div", { className: 'page-content-wrapper rally-preview-page', children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: '/' }), rally && (_jsxs(_Fragment, { children: [_jsxs(PageMainContent, { children: [_jsx(Hero, { imageSrc: heroImage, imagePosition: 'bottom right', title: rally.publicTitle, backgroundColor: 'rgba(0, 161, 154, 0.2)' }), _jsx(RallyInfoCard, { themes: rally.themes, geographicArea: rally.geographicArea, targetGroups: rally.targetGroups }), _jsx(TextContent, { content: rally.description, html: true })] }), _jsx(PageBottomContent, { children: _jsxs(ButtonsGroup, { justify: 'between', children: [_jsx(Button, { label: t('button.back'), variant: 'outlined', onClick: () => navigate('/') }), _jsx(Button, { label: t('button.start_rally'), onClick: () => navigate(generateIdRoutePath(APP_ROUTES.rallyRegistration, rally.uuid)) })] }) })] }))] }) }));
};
export default RallyPreviewPage;
